import React from "react";

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen text-white bg-[#0b0f19] py-16 px-6 max-w-4xl mx-auto leading-relaxed">

      <h1 className="text-4xl font-bold mb-6 text-cyan-400">Privacy Policy</h1>

      <p className="mb-4">
        This Privacy Policy describes how NuclearEnergyAgent.com ("we", "our", "the Service") collects, uses, and protects your personal data.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">1. Information We Collect</h2>
      <p className="mb-4">
        We collect limited technical and usage information, including:
      </p>
      <ul className="list-disc pl-6 mb-4">
        <li>Anonymous user identifier (UUID)</li>
        <li>Uploaded documents strictly for generating summaries</li>
        <li>Summary outputs and extracted variables</li>
        <li>Basic browser metadata</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-3">2. How We Use Your Data</h2>
      <p className="mb-4">
        We use your information ONLY to:
      </p>
      <ul className="list-disc pl-6 mb-4">
        <li>Generate summaries and variable extractions</li>
        <li>Improve accuracy and reliability of the agent</li>
        <li>Track usage for credit plans</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-3">3. Document Handling</h2>
      <p className="mb-4">
        Uploaded files are processed temporarily in memory and are never sold, shared, or redistributed.
        For security, PDFs and text files may be inspected by automated systems to extract content.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">4. Data Security</h2>
      <p className="mb-4">
        All data is transmitted securely using HTTPS. Access to internal systems is restricted and monitored.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">5. Payment Information</h2>
      <p className="mb-4">
        Payments are processed through Stripe. We do not store credit card information.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">6. Contact</h2>
      <p className="mb-4">
        For questions, email us at:
        <span className="text-cyan-400 font-semibold ml-1">support@nuclearenergyagent.com</span>
      </p>

      <p className="mt-10 opacity-70">Last updated: November 2025</p>

    </div>
  );
}
